import { createCustomerOrgUnitScope } from '@/helpers/queryKeyScopes'

import type { SortByEnumSchema } from '@/schemas/sortDirectionEnumSchema'

const scope = createCustomerOrgUnitScope('getFavoriteListFull')

export const getFavoriteListFullKeys = {
  ...scope,
  withFavoriteList: (
    customerId: string,
    orgUnitId: string,
    listId: string,
    currentPage: number,
    itemsPerPage: number,
    sortBy: SortByEnumSchema,
    searchText: string
  ) => {
    return [...scope.orgUnit(customerId, orgUnitId), listId, currentPage, itemsPerPage, sortBy, searchText]
  },
} as const
